// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__1J6bq","img":"style_img__1ZTqj"};